<template>
  <v-slide-group class="text-center justify-center" :style="{width:'100%'}">
    <v-bottom-navigation
        background-color="transparent"
        dark grow color="yellow"
        :value="$store.getters.getExtensionMenuSelected"

    >

      <v-btn
          v-for="menu in $store.getters.extensionMenu"
          :key="menu.id"
          @click="$vuetify.goTo('#' + menu.id)"
          :value="menu.id"
          max-width="100"
      >
        <span v-for="word in menu.name.split(' ')" :key="word">{{ word }}</span>
        <v-icon>{{ menu.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-slide-group>

</template>

<script>
export default {
  name: "ExtendedBtnMenu",
}
</script>

<style scoped>

</style>
